import React, { Component } from 'react'
// import Notifications from './Notifications';
import ProjectList from '../projects/ProjectList';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import VerifyEmail from '../layout/VerifyEmail';
import { compose } from 'redux';
import { Redirect, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
class Dashboard extends Component {
	state = {
		searchw: null
	}

	handleChange = (e) => {
		this.setState({
			[e.target.id]: e.target.value
		})
	}

	render() {
		const { projects1, projects2, createCounts, profile, auth } = this.props;

		let chartdata = [];
		if (createCounts) {
			if (createCounts.length > 0) {
				let raw = createCounts[0]

				for (var i = 0; i < 3; i++) {
					// for (var i = 0; i < chartkeys.length; i++) {
					let tmp = { "name": null, "y": null }
					let d = new Date();
					d.setDate(1);
					d.setMonth(d.getMonth() - (2 - i));
					let tmpm = d.getUTCMonth() + 1;
					let tmpy = d.getUTCFullYear();
					let tmpyyyymm = tmpy + "-" + tmpm
					tmp.name = tmpyyyymm
					tmp.y = raw[tmpyyyymm] ? raw[tmpyyyymm] : 0
					chartdata.push(tmp)
				}
			}
		}

		let barchart;
		if (chartdata.length > 0) {
			barchart = <ResponsiveContainer width="100%" aspect={3.0 / 1.0}>
				<LineChart width={500} height={200} data={chartdata}>
					<Line type="monotone" dataKey="y" stroke="#8884d8" />
					<XAxis dataKey="name" />
					<YAxis />
					<Tooltip />
				</LineChart>
			</ResponsiveContainer>
			// barchart = <XYPlot
			// 	margin={{ bottom: 40, top: 40 }}
			// 	width={600}
			// 	height={200}
			// 	xType="ordinal">
			// 	<VerticalGridLines />
			// 	<HorizontalGridLines />
			// 	<LineSeries
			// 		data={chartdata} />
			// 	<XAxis />
			// 	<YAxis />
			// </XYPlot>
		}
		let projects1_filtered = projects1 && this.state.searchw ? projects1.filter(s => s.title.includes(this.state.searchw)) : projects1
		let projects2_filtered = projects2 && this.state.searchw ? projects2.filter(s => s.title.includes(this.state.searchw)) : projects2
		if (!auth.uid) {
			return <Redirect to={'/signin'} />
		} else if (auth.uid && !profile.esign && profile.isLoaded) {
			return <Redirect to={'/mysign'} />
		}

		if (auth.emailVerified) {
			if (typeof projects1 === 'undefined' && typeof projects2 === 'undefined') {
				return (
					<div className="grey lighten-5">
						<div className="row">
							<div className="row"></div>

							<div className="col s12 m12">
								<h5 className="header center black-text text-lighten-2">You don't have NDA yet. Let's create one!</h5>
								<div className="row">
									<div className="col m4 s4 offset-m5 waves-effect waves-light lighten-1">
										<Link to='hastemplate' key='Hastemplate' className='btn btn-large teal waves-effect waves-light lighten-1'>New NDA</Link>
									</div>
								</div>
							</div>
							<div className="row"></div>
							<div className="row"></div>
							<div className="row"></div>
							<div className="row"></div>
							<div className="row"></div>
							<div className="row"></div>
							<div className="row"></div>
							<div className="row"></div>
							<div className="row"></div>
							<div className="row"></div>
							<div className="row"></div>
							<div className="row"></div>
							<div className="row"></div>
							<div className="row"></div>
							<div className="row"></div>
						</div >
					</div>
				)
			} else {
				return (
					<div className="grey lighten-5">
						{/* <div className="dashboard container"> */}
						<div className="row">

							<div className="col s12 m2 offset-m1">
								<div className="row"></div>
								<div className="row"></div>
								<div className="row"></div>
								<div className="row"></div>
								<div className="card">
									<div className="card-content">
										<div className="input-field">
											<label htmlFor="searchw"><FontAwesomeIcon icon="search" /></label>
											<input type="text" id="searchw" onChange={this.handleChange} />
										</div>
									</div>
								</div>
							</div>
							<div className="col s12 m6">
								<h5 className="header center black-text text-lighten-2">Activity log</h5>
								{barchart}
							</div>
						</div>

						<div className="row">
							<div className="col s12 m3 offset-m3">
								<h5 className="header center black-text text-lighten-2">Created by You</h5>

								<ProjectList projects={projects1_filtered} />
							</div>

							<div className="col s12 m3">
								<h5 className="header center black-text text-lighten-2">Created for You</h5>
								<ProjectList projects={projects2_filtered} />
							</div>
							<div className="row">
							</div>
							<div className="row">
							</div>
							<div className="row">
							</div>
							<div className="row">
							</div>
							<div className="row">
							</div>
							<div className="row">
							</div>
							{/* <div className="col s12 m5 offset-m1">
						<Notifications notifications={notifications} />
					</div> */}
							{/* </div> */}
						</div >
					</div >
				)
			}
		} else if (auth && !auth.emailVerified) {
			return (
				<VerifyEmail auth={auth} />
			)
		}

	}
};

const mapStateToProps = (state) => {
	return {
		projects1: state.firestore.ordered.projects1,
		projects2: state.firestore.ordered.projects2,
		createCounts: state.firestore.ordered.createCounts,
		profile: state.firebase.profile,
		auth: state.firebase.auth,
		// notifications: state.firestore.ordered.notifications
	}
}



export default compose(
	connect(mapStateToProps),
	firestoreConnect(
		// [
		// {collection: 'projects' },
		// {collection: 'projects', limit: 5, orderBy: ['createdAt', 'desc'], queryParams: ['email2=test2@ninjaplatform.com'] },
		// {collection: 'notifications', limit: 5, orderBy: ['time', 'desc'] }
		// ]
		(props) => [
			{ collection: 'createCounts', where: ['authorId', '==', props.auth.uid], storeAs: 'createCounts' },
			{ collection: 'projects', where: ['authorId', '==', props.auth.uid], orderBy: ["createdAt", "desc"], storeAs: 'projects1' },
			{ collection: 'projects', where: ['email2', '==', props.auth.email], orderBy: ["createdAt", "desc"], storeAs: 'projects2' }
		]

	),
)(Dashboard);